import React, {Component} from 'react'
import Grid from "../../../Utils/Grid";
import {TableHeaderColumn} from "react-bootstrap-table";
import Card from "Utils/Cards/Card";
import moment from 'moment';


export default class NoCanjeadosGrid extends Component{

    componentWillMount() {
        const { listarNoCanjeados } = this.props;
        listarNoCanjeados();
    }

    render() {
        const { listarNoCanjeados: onPageChange } = this.props; //Funciones
        const { data2, loader, page2 } = this.props; //Constantes
        return(
            <div className="col-12 mt-4">
                <Card>
                    <Grid hover striped data={data2} loading={loader} onPageChange={onPageChange}
                    page={page2}>
                        <TableHeaderColumn
                            dataField="id"
                            dataAlign="center"
                            isKey
                            width='5%'
                            dataFormat={cell => ""}
                        />
                        <TableHeaderColumn
                            dataField="creado"
                            dataFormat={cell => moment(cell).format("DD/MM/YYYY")}
                        >
                            FECHA
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="encabezado"
                            dataFormat={cell => cell.colaborador ? `${cell.colaborador.nombres} ${cell.colaborador.apellidos}` : '----'}
                        >
                            COLABORADOR
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="encabezado"
                            dataFormat={cell => cell.centro_colaborador ? `${cell.centro_colaborador.nombre}` : '----'}
                        >
                            CENTRO COLABORADOR
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="encabezado"
                            dataFormat={cell => cell.recurrente ? 'Recurrente' : 'No recurrente'}
                        >
                            TIPO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="cupon"
                        >
                            CÓDIGO
                        </TableHeaderColumn>
                    </Grid>
                </Card>
            </div>
        )
    }
}
